import React from 'react';

import { ManageOrganizationWrapper } from 'screens/organizations/context/EditOrganizationProvider';

import OrganizationTitlesCreate from 'screens/organizations/components/OrganizationTitleCreate';

const OrganizationTitlesCreateScreen = () => <OrganizationTitlesCreate />;

export default OrganizationTitlesCreateScreen;

OrganizationTitlesCreateScreen.getLayout = (page) => (
  <ManageOrganizationWrapper>{page}</ManageOrganizationWrapper>
);
